import { useEffect, useState } from 'react';

const ScrollDirection = {
  up: 'up',
  down: 'down',
};

export const useScrollDirection = (threshold, onceDetect = false) => {
  const [scrollDir, setScrollDir] = useState(null);
  useEffect(() => {
    let previousScrollYPosition =
      document?.getElementById('bodyWrapper')?.scrollTop;

    const scrolledMoreThanThreshold = (currentScrollYPosition) =>
      Math.abs(currentScrollYPosition - previousScrollYPosition);

    const isScrollingUp = (currentScrollYPosition) => {
      return (
        currentScrollYPosition > previousScrollYPosition &&
        !(previousScrollYPosition > 0 && currentScrollYPosition === 0) &&
        !(currentScrollYPosition > 0 && previousScrollYPosition === 0)
      );
    };

    const updateScrollDirection = () => {
      const currentScrollYPosition =
        document?.getElementById('bodyWrapper')?.scrollTop;
      if (currentScrollYPosition <= threshold) {
        return setScrollDir(null);
      }
      if (scrolledMoreThanThreshold(currentScrollYPosition)) {
        const newScrollDirection = isScrollingUp(currentScrollYPosition)
          ? ScrollDirection.down
          : ScrollDirection.up;
        if (onceDetect && newScrollDirection === scrollDir) return;
        setScrollDir(newScrollDirection);
        previousScrollYPosition =
          currentScrollYPosition > 0 ? currentScrollYPosition : 0;
      }
    };

    const onScroll = () => window.requestAnimationFrame(updateScrollDirection);
    window.addEventListener('scroll', onScroll, true);

    return () => window.removeEventListener('scroll', onScroll);
  }, [scrollDir]);

  return scrollDir;
};
